import { MEDIA_ITEMS, UPDATES_ITEMS, INDEX_ITEMS } from '@/mocks/home';

export function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-3">
          精彩花絮
        </h2>
        <p className="text-sm text-foreground-600 text-center mb-10 max-w-lg mx-auto">
          热门电影专区速览，发现你的下一部心头好
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {MEDIA_ITEMS.map((item, idx) => (
            <div key={idx} className="group bg-background-100 rounded-lg overflow-hidden cursor-pointer">
              <div className="relative aspect-[16/10] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                <div className="absolute bottom-3 left-3 right-3">
                  <h3 className="text-sm font-heading font-semibold text-white">{item.title}</h3>
                </div>
              </div>
              <div className="p-3">
                <p className="text-xs text-foreground-500 leading-relaxed">{item.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-3xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-3">
          最新动态
        </h2>
        <p className="text-sm text-foreground-600 text-center mb-10">
          555电影网平台更新与内容动态速览
        </p>
        <div className="relative">
          <div className="absolute left-4 top-0 bottom-0 w-px bg-background-300/60"></div>
          <div className="space-y-5">
            {UPDATES_ITEMS.map((item, idx) => (
              <div key={idx} className="relative flex items-start gap-4 pl-10">
                <div className="absolute left-[10px] top-2 w-2.5 h-2.5 rounded-full bg-accent-500 ring-4 ring-background-100"></div>
                <div className="flex-1">
                  <div className="flex items-center gap-2 mb-1 flex-wrap">
                    <span className="text-xs text-foreground-400">{item.date}</span>
                    <span className="inline-flex px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 text-[10px] font-medium whitespace-nowrap">
                      {item.tag}
                    </span>
                  </div>
                  <p className="text-sm text-foreground-800">{item.title}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-3">
          影视导航
        </h2>
        <p className="text-sm text-foreground-600 text-center mb-10 max-w-lg mx-auto">
          按类型快速浏览，精准找到你想看的电影
        </p>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          {INDEX_ITEMS.map((item, idx) => (
            <a
              key={idx}
              href="#cards"
              className="group bg-background-100 hover:bg-background-200 rounded-lg p-5 transition-colors cursor-pointer"
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 mb-3">
                <i className={`${item.icon} text-lg text-primary-600`}></i>
              </div>
              <h3 className="text-base font-heading font-semibold text-foreground-900 mb-1">{item.title}</h3>
              <p className="text-xs text-foreground-500 mb-2">{item.description}</p>
              <span className="text-xs font-medium text-primary-600">{item.count} 部影片</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}